import { useAppDispatch, useAppSelector } from "./redux";
import commonservice from "@apis/commonservice";
import { getProfile } from "@apis/http/api";
import { useModalTip } from "@components/ModalAutoAlert";
import PhoneVertifyModal from "@components/PhoneVertifyModal";
import report from "@report";
import { queryMembership, updateUserInfo } from "@store/globalSlice";
import { queryMemberships } from "@store/memberCenterSlice";
import { LoginMethodStorage } from "@utils/storage";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const useVerifyPhone = ({
  verifySuccess,
  verifyError,
}: {
  verifySuccess?: Function;
  verifyError?: Function;
}) => {
  const [open, setOpen] = useState(false);
  const { userInfo, region } = useAppSelector((state) => state.globalReducer);
  const dispatch = useAppDispatch();
  const successModalTip = useModalTip({
    type: "confirm",
    title: userInfo.subAccount ? "Verified successfully" : "Congratulations on getting 1-day standard membership!",
    subtitle: "You can also log in with this Phone Number.",
  });
  const { t } = useTranslation();
  const { membership } = useAppSelector((state) => state.globalReducer);

  const errorModalTip = useModalTip({
    type: "error",
    title: "Verified unsuccessfully",
  });
  // 手机号验证
  const onVertifyPhone = async (formData: { phone: string; prefix: string; captcha: string }) => {
    const data: {
      loginMethod: "SMS" | "TIKTOK";
      phoneCountryCode: string;
      phoneNumber: string;
      smsCode: string;
    } = {
      loginMethod: "SMS",
      phoneCountryCode: formData.prefix,
      phoneNumber: formData.phone?.trim?.() || "",
      smsCode: formData.captcha?.trim?.() || "",
    };
    return commonservice
      .verifyAccount(data)
      .then(() => {
        report.event("phone_vericaty_success", {
          kalo_type: data.loginMethod,
        });
        verifySuccess?.();
        LoginMethodStorage("sms");
        setOpen(false);
        const level = membership?.level === "Trial" ? "Standard" : membership?.level;
        successModalTip.open({
          type: "confirm",
          title: userInfo.subAccount
            ? "Verified successfully"
            : `Congratulations on getting 1-day ${level?.toLocaleLowerCase()} membership!`,
          subtitle: "You can also log in with this Phone Number.",
        });
        getProfile().then((res) => {
          dispatch(updateUserInfo(res));
          dispatch(queryMembership({ country: region }));
          dispatch(queryMemberships());
        });
      })
      .catch((err) => {
        report.event("phone_vericaty_error", {
          kalo_type: data.loginMethod,
          kalo_value: err,
        });
        verifyError?.(err);
        if (err.code == "1114") {
          err.message = t("The number is linked to another account. You can try another number.");
          errorModalTip.open({
            title: "Authorized failure",
            subtitle: t(err.message),
          });
          return;
        }
        throw err.message || err;
      });
  };

  const verifyPhoneModal = () => {
    return (
      <>
        <PhoneVertifyModal onSubmit={onVertifyPhone} setOpen={setOpen} open={open} />
        {successModalTip.showDom()}
        {errorModalTip.showDom()}
      </>
    );
  };

  return {
    setOpen,
    open,
    verifyPhoneModal,
  };
};
